// Lot 671 — pont vers le plugin iOS maison « YalolaNative » (ios/App/App/YalolaNativePlugin.swift) : touches de volume
// démarrées à la demande (plus au lancement), mémoire du processus et avertissements mémoire iOS pour l'enregistreur
// de vol. Hors iPhone (web, Android) : tout est sans effet et ne rejette jamais.
import { Capacitor, registerPlugin } from "@capacitor/core";

const isIos = () => Capacitor.isNativePlatform() && Capacitor.getPlatform() === "ios";
let plugin = null;
const get = () => {
  if (!isIos()) return null;
  if (!plugin) plugin = registerPlugin("YalolaNative");
  return plugin;
};

export const startNativeVolumeKeys = async () => {
  const p = get();
  if (!p) return false;
  try { await p.startVolumeKeys(); return true; } catch { return false; }
};
// Lot 678 — fin d'un écran média : observateur libéré, session audio désactivée (plus rien ne tourne).
export const stopNativeVolumeKeys = async () => {
  const p = get();
  if (!p) return false;
  try { await p.stopVolumeKeys(); return true; } catch { return false; }
};

// { footprintMb, availableMb, totalMb } du processus de l'app (le processus WebKit de la page est distinct) ; null ailleurs.
export const nativeMemoryInfo = async () => {
  const p = get();
  if (!p) return null;
  try { return await p.memoryInfo(); } catch { return null; }
};

export const onNativeEvent = (name, cb) => {
  const p = get();
  if (!p || typeof p.addListener !== "function") return () => {};
  let handle = null;
  try { handle = p.addListener(name, cb); } catch { return () => {}; }
  return () => { Promise.resolve(handle).then((h) => h?.remove?.()).catch(() => {}); };
};

// Lot 681 — diagnostics iOS MetricKit en attente (« hang » = interface figée, l'équivalent des ANR Android ; plantages),
// renvoyés une seule fois par le natif. [] ailleurs ou en cas d'erreur.
export const nativeLastExits = async () => {
  const p = get();
  if (!p) return [];
  try { const r = await p.lastExits(); return Array.isArray(r?.items) ? r.items : []; } catch { return []; }
};
